<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 clientStaffTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="client_staff"
                        arrows >
                    <template slot="gofixTab:client_staff">
                        <gofix-card fullContent class="mb-0">
                            <gofix-default-table :settings="tableConfig"
                                                 :table-items="tableItems"
                                                 @load-items="getTableData"
                                                 @new-item="openCreateItem"
                                                 @row-click="openCreateItem"
                                                 @delete-items="deleteItems"
                                                 ref="gofixTable">
                                <template slot="gofix_table:active" slot-scope="row">
                                    <span class="text-highlight">{{ row.item.active ? "Active" : "Inactive" }}</span>
                                </template>
                                <template slot="gofix_table:start_date" slot-scope="row">
                                    {{ row.item.start_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY") }}
                                </template>
                                <template slot="gofix_table:end_date" slot-scope="row">
                                    {{ row.item.end_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY") }}
                                </template>
                            </gofix-default-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.create.title" hide-footer :centered="true"
                 v-model="modals.create.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Select by Name or Email"
                                desc="Search by name or email"
                                vLabel="name"
                                @search="searchUser"
                                @change="selectUser"
                                :filterable="false"
                                :options="modals.create.users.data"
                                :disabled="!!modals.create.data.id"
                                v-model="modals.create.client">
                                <template #gofixInput:dropdown:option="{ name, email }">
                                    {{name}} - {{email}}
                                </template>
                                <template #gofixInput:dropdown:selected-option="{ name, email }">
                                    {{name}} - {{email}}
                                </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Role"
                                vLabel="name"
                                :filterable="false"
                                :multiple="!modals.create.data.id"
                                :required="true"
                                :reduce="option => option.id"
                                v-model="modals.create.data.role_id"
                                :options="modals.create.roles">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-properties
                                label="Property"
                                :contract-id="$route.params.id"
                                :property-id="ClientContractID ? ClientContractID.property_root_id : null"
                                v-model="modals.create.data.property"
                                valueFormat="object"
                                required>
                        </gofix-form-properties>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-tree
                            label="Service Category"
                            :default-expand-level="1"
                            :multiple="false"
                            :options="modals.create.service_categorys"
                            :load-options="loadOptionServices"
                            :normalizer="normalizer"
                            search-nested
                            valueFormat="object"
                            v-model="modals.create.data.service_category"
                            placeholder="Select"
                            ref="input">
                        </gofix-form-tree>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="modals.create.data.start_date"
                                label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="modals.create.data.end_date"
                                label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
            </b-form>

            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="saveData" :loading="modals.create.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import tabData from '@/data/_tabs';
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    export default {
        name: 'contract-client-staff',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['client_staff']));
            return {
                contract_tab: tabData.client_contract,
                tableConfig:{
                    name: 'client-contract-client-staff',
                    controls:{
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "user_id",
                    sortDirection: "asc"
                },
                tableItems: [],
                modals:{
                    create:{
                        open: false,
                        loading: false,
                        title:"Add Client Staff",
                        data:{
                            id: null,
                            user_id: null,
                            service_category_id: null,
                            service_category: null,
                            start_date: null,
                            end_date: null,
                            contract_id: this.$route.params.id,
                            property_id: null,
                            property: null,
                            role_id: null,
                            type: "Client",
                        },
                        users:{
                            data:[],
                            timer: null
                        },
                        client: null,
                        properties:[],
                        roles: [],
                        service_categorys: []
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch: {
            ClientContractID: function (val, old) {
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }
                if(old && val && val.id != old.id) {
                    this.getUsers();
                    this.loadRootServiceCategory();
                }
            },
        },
        created() {
            if(!this.modals.create.users.length && this.ClientContractID && this.ClientContractID.id) {
                this.getUsers();
                this.loadRootServiceCategory();
            }
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.company_id.value = -1;
                if(this.ClientContractID && this.ClientContractID.client_id) {
                    tableRequest.filter.company_id.value = this.ClientContractID.client_id;
                }
                tableRequest.filter.user_type.value = 'Client';
                tableRequest.staff = true
                if(tableRequest.filter.contract_id.value) {
                    await this.$store.dispatch("UserDutyController/getItems", tableRequest)
                        .then(response => {
                            this.tableItems = response.items;
                            this.tableConfig.total = response.total;
                            resolve(response);
                        })
                        .catch(err => {
                            this.$alertNotification("Can not load the items", "danger");
                            reject();
                        })
                }
            },
            selectUser(item){
                this.modals.create.roles = item.roles;
                this.modals.create.data.user_id = item.id;
                this.modals.create.data.role_id = item.roles.map(x => x.id);
            },
            getUsers(){
                this.$store.dispatch("v2UserController/searchListUser",
                    {page:1, totalPage : 0, limit:100, filters:{ name: '', organization_isfm : false , organization_is_supplier: false, organisation_id: this.ClientContractID.client_id }})
                    .then(result=>{
                        this.modals.create.users.data = result.data
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            openCreateItem(item){
                if(!this.ClientContractID || !this.ClientContractID.client_id) {
                    return this.$alertNotification("You cannot create a client staff because you have not added a client to a contract.", "danger");
                }
                this.modals.create.open = true;
                if(item){
                    this.modals.create.title = "update client staff";
                    this.modals.create.data = {
                        id: item.id,
                        user_id: item.user_id,
                        start_date: item.start_date ? moment(item.start_date).toDate() : null,
                        end_date: item.end_date ? moment(item.end_date).toDate() : null,
                        contract_id: this.$route.params.id,
                        property_id:  item.property_id,
                        property: {
                            "id": item.property_id,
                            "name": item.property_name,
                            "text": item.property_name,
                            "data": {
                                "id": item.property_id,
                                "name": item.property_name,
                            },
                        },
                        user_id: item.user_id,
                        role_id: item.role_id,
                        service_category_id: item.service_category_id ? item.service_category_id : null,
                        service_category: item.service_category_id ? {
                            "id": item.service_category_id,
                            "name": item.service_category_name,
                            "text": item.service_category_name,
                            "data": {
                                "id": item.service_category_id,
                                "name": item.service_category_name,
                            },
                        } : null,
                    };
                    this.modals.create.client = {
                        id: item.user_id,
                        name:item.user_name,
                        email:item.user_email,
                    }
                    for( let i = 0 ; i <  this.modals.create.users.data.length ; i++ ){
                        if(item.user_id === this.modals.create.users.data[i].id){
                            this.modals.create.roles = this.modals.create.users.data[i].roles;
                        }
                    }
                }else{
                    this.modals.create.client = null;
                    this.modals.create.title = "Add Client Staff";
                    this.modals.create.data = {
                        id: null,
                        user_id: null,
                        role_id: null,
                        start_date: null,
                        end_date: null,
                        contract_id: this.$route.params.id,
                        property_id: null,
                        property: null,
                        type: "Client",
                        service_category_id: null,
                        service_category: null,
                    };
                }
            },
            searchUser (search, loading){
                loading(true);
                if(this.modals.create.users.timer) {
                    clearTimeout(this.modals.create.users.timer);
                    this.modals.create.users.timer = null;
                }
                this.modals.create.users.timer = setTimeout(() => {
                    this.$store.dispatch("v2UserController/searchListUser", {page:1, totalPage : 0, limit:1000, filters:{ name: '', organization_isfm : false , organization_is_supplier: false, organisation_id: this.ClientContractID ? this.ClientContractID.client_id : '' }})
                        .then(response => {
                            this.modals.create.users.data = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("UserDutyController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'client_staff'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            saveData() {
                if(!this.modals.create.data.user_id) return this.$alertNotification("Please select user", "danger");

                if(!this.modals.create.data.role_id) return this.$alertNotification("Please select a role", "danger");

                if(!this.modals.create.data.property) return this.$alertNotification("Please select a property", "danger");

                if(!this.modals.create.data.service_category) return this.$alertNotification("Please select a service category", "danger");

                if(this.modals.create.loading) return;
                this.modals.create.loading = true;
                let request = Object.assign({}, this.modals.create.data);
                request.start_date = request.start_date ? moment(request.start_date).format("YYYY-MM-DD") : null;
                request.end_date = request.end_date ? moment(request.end_date).format("YYYY-MM-DD") : null;
                request.property_id = request.property ? request.property.id : null;
                request.service_category_id = request.service_category ? request.service_category.id : null;
                let action = 'createItem';
                let keyMsg = 'adding'
                if(request.id){
                    action = 'updateItem';
                    keyMsg = 'editing'
                }
                this.$store.dispatch(`UserDutyController/${action}`, request)
                    .then(result => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        //this.$notificationV2('custom', 'user_duty_assign')
                        this.$alertNotification(this.$notificationV2(keyMsg, 'client_staff'));
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                        return this.$alertNotification(error.response.data.error.message.error, "danger");
                    })
            },
            goToDetail(){
                let id = "add";
                if(this.modals.create.data.id) id = this.modals.create.data.id;
                return this.$router.push(`/v2/contract-client/${this.$route.params.id}/client-staff/${id}`);
            },
            normalizer(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children,
                    };
                return {
                    id: node.data.id,
                    label: node.text,
                    children: undefined
                };
            },
            loadRootServiceCategory(){
                this.$store.dispatch('ServiveCategoryController/getServiceCategories', {
                    contractId: this.$route.params.id,
                    categoryId: 0
                }).then(response => {
                    this.modals.create.service_categorys = response;
                });
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("ServiveCategoryController/getServiceCategories", {
                        contractId: this.$route.params.id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }
            },
        }
    }
</script>